<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication">
<p class="center"><em>To Sunshine, the other redhead in my life</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?420a6232